import { Card } from '@nackle/paper';
import { RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';
import {
    formatCmxCabinetDescKey,
    formatCmxCabinetInstructionsKey,
    formatCmxCabinetNameKey
} from 'routes/updatecmx/cmxKeyNames';
import { TranslationEditorWrapper } from 'routes/updatecmx/TranslationEditorWrapper';
import { CardHeader } from 'shared/card-header';

interface Props extends RouteComponentProps {
    cabinetId: string;
    // elevation?: Elevation;
    onChildPanelOpening: () => void;
    onChildPanelClosed: () => void;
    usePortal?: boolean;
}

export class CabinetContentForm extends Component<Props> {
    render() {
        const { cabinetId, onChildPanelOpening, onChildPanelClosed, usePortal } = this.props;

        return (
            <Card>
                <CardHeader className="localizable-content" title="Localizable Content" />

                <TranslationEditorWrapper
                    keyName={formatCmxCabinetNameKey(cabinetId)}
                    label="Game Name"
                    onPanelOpening={onChildPanelOpening}
                    onPanelClosed={onChildPanelClosed}
                    usePortal={usePortal}
                />

                <TranslationEditorWrapper
                    keyName={formatCmxCabinetDescKey(cabinetId)}
                    label="Game Description"
                    onPanelOpening={onChildPanelOpening}
                    onPanelClosed={onChildPanelClosed}
                    usePortal={usePortal}
                />

                <TranslationEditorWrapper
                    keyName={formatCmxCabinetInstructionsKey(cabinetId)}
                    label="Instructions"
                    onPanelOpening={onChildPanelOpening}
                    onPanelClosed={onChildPanelClosed}
                    usePortal={usePortal}
                />
            </Card>
        );
    }
}
